import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PermitPaths } from "../../../permit-paths";
import { PermitCreateSelectors } from "../../../permit-create/states/permit-create.selectors";
import { PermitBasicDetailsDto } from "../../models/permit-basic-details.model";
import { PermitDetailsActions } from "../../states/permit-details.action";
import { PermitDetailsSelectors } from "../../states/permit-details.selectors";

@Component({
    selector: "pmt-permit-completed",
    templateUrl: "./permit-completed.component.html",
    styleUrls: ["./permit-completed.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitCompletedComponent {
    @Select(PermitDetailsSelectors.basicDetails)
    public basicDetails$: Observable<PermitBasicDetailsDto>;

    @Select(PermitDetailsSelectors.showFlammableAtexPermitCreated)
    public showFlammableAtexPermitCreated$: Observable<boolean>;

    public PermitPaths = PermitPaths;

    constructor(private store: Store, private activatedRoute: ActivatedRoute, private router: Router) { }

    public refresh(): void {
        const showFlammableAtexPermitCreated = this.store.selectSnapshot(PermitDetailsSelectors.showFlammableAtexPermitCreated);
        if (showFlammableAtexPermitCreated) {
            const returnToPermitIdFromQuery = Number(this.activatedRoute.snapshot.queryParamMap.get("returnToPermitId"));
            const permit = this.store.selectSnapshot(PermitCreateSelectors.permit);
            const returnToPermitId = !Number.isNaN(returnToPermitIdFromQuery) && returnToPermitIdFromQuery > 0
                ? returnToPermitIdFromQuery
                : (permit?.returnToPermitId ?? 0);
            this.store.dispatch(new PermitDetailsActions.ShowFlammableAtexPermitCreated(false));

            if (returnToPermitId > 0) {
                void this.router.navigate([PermitPaths.Root, returnToPermitId.toString()], { replaceUrl: true });
                return;
            }

            void this.router.navigate([PermitPaths.Root], { replaceUrl: true });
            return;
        }

        this.store.dispatch(new PermitDetailsActions.ShowPermitStarted(false));
    }
}
